import { boundActionsFactory } from 'shared/hooks/useBoundActions';
import { trackBookingSend } from 'shared/store/analytics/actions/trackBookingSend';

export const useBookCoworkingModalBoundActions = boundActionsFactory({
  trackBookingSend,
});
